import { c as _c } from "react/compiler-runtime";
import { SectionHeadline } from '@/components/SectionHeadline';
import { StackCards } from '@/components/StackCards';
import { Card } from '@/components/StackCards/types';
import { Button } from '@/components/buttons';
import { Link } from '@/components/links';
import { LINKS, SELF_CARE_LINKS } from '@/constants/links';
import { NumericRange } from '@/types/range';
import { mergeClasses } from '@/utils/style';
import { Trans, useTranslation } from 'react-i18next';
export function Cards() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["rewards"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = Array.from({
      length: 5
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 5>;
      return {
        index,
        title: <div className={mergeClasses(cardIndex === 5 && "text-center lg:text-left")}>{t(`rewards:howToEarn.items.${cardIndex}.title`)}</div>,
        ...(cardIndex < 5 ? {
          description: <Trans t={t} i18nKey={`rewards:howToEarn.items.${cardIndex}.description`}><Link analyticsParam="rewardsCardsCard" testId="rewardsCardsCard" to={LINKS().card} /></Trans>
        } : {
          footer: <Button analyticsParam="rewardsCardGet" testId="rewardsCardGet" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" to={SELF_CARE_LINKS.rewardsOverview}>{t("rewards:howToEarn.button")}</Button>
        }),
        images: {
          desktop: {
            src: `/images/sections/rewards/cs/cards/${cardIndex}.png`,
            alt: t(`rewards:howToEarn.items.${cardIndex}.title`)
          },
          mobile: {
            src: `/images/sections/rewards/cs/cards/${cardIndex}.png`,
            alt: t(`rewards:howToEarn.items.${cardIndex}.title`)
          }
        }
      } satisfies Card;
    });
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cards = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("rewards:howToEarn.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <SectionHeadline className="mb-12 whitespace-pre-wrap lg:mb-16" anchorKey="rewards.howToEarn.title">{t2}</SectionHeadline>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cards) {
    t4 = <StackCards imagePosition="left" cards={cards} />;
    $[7] = cards;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <section>{t3}{t4}</section>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}